import { FetchStatus } from '@powdr/constants';

import {
  ALERTS_PENDING,
  ALERTS_SUCCESS,
  ALERTS_ERROR,
} from '../types';

const initialAlertState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

const initialState = {
  alerts: {
    data: [],
    status: FetchStatus.IDLE,
    error: null,
  },
  headerAlert: {
    ...initialAlertState,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ALERTS_PENDING: {
      const { key } = action.payload;

      return {
        ...state,
        [key]: {
          ...state[key],
          status: FetchStatus.LOADING,
          error: null,
        },
      };
    }

    case ALERTS_SUCCESS: {
      const { key, data } = action.payload;

      return {
        ...state,
        [key]: {
          ...state[key],
          data,
          status: FetchStatus.SUCCESS,
          error: null,
        },
      };
    }

    case ALERTS_ERROR: {
      const { key, error } = action.payload;

      return {
        ...state,
        [key]: {
          ...state[key],
          status: FetchStatus.ERROR,
          error,
        },
      };
    }

    default:
      return state;
  }
};
